// extracted by mini-css-extract-plugin
export default {"box":"file-image_box__bHzUe","download":"file-image_download__UCkg2","downloadIcon":"file-image_downloadIcon__Cy2QS","skeleton":"file-image_skeleton__kssKG"};